












import { getDefaultThumbnailForProductType } from '@/web/utils/media';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { getProductTypeTranslations } from '@/core/utils/products';

export default {
  name: 'ProductThumbnail2',
  props: {
    product: {
      type: Object as () => ProductResponse,
      required: true,
    },
    showNewTag: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style(): object | null {
      if (this.product.thumbnail_file) {
        const file = this.product.thumbnail_file as PhotoResponse;
        let thumbnailUrl = file.thumbnail;
        if (file.image_url) thumbnailUrl = file.image_url;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      if (this.product.cover_file) {
        const file = this.product.cover_file as PhotoResponse;
        let thumbnailUrl = file.thumbnail;
        if (file.image_url) thumbnailUrl = file.image_url;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      const thumbnailUrl = getDefaultThumbnailForProductType(
        this.product?.product_type
      );
      return {
        backgroundImage: 'url(' + thumbnailUrl + ')',
      };
    },
    isNew() {
      const isNew = moment(this.product.created).isAfter(
        moment().subtract({ days: this.product.media_new_tag_days })
      );
      return isNew;
    },
  },
};
